module.exports = __webpack_public_path__ + "img/sign-in-2.adb3b465.png";